import 'rc-notification/assets/index.css';
import './style/index.css';
import Notification from 'rc-notification';
import { Button, Icon } from 'antd';
import React from 'react';
let notification = Notification.newInstance({
  style: {
    top: '40%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    'borderRadius': 8,
    // marginRight: '-50%', transform:'translate(-50%,-50%)'
  }
});
export function success(message) { }
export function warning(message) { }
/**
 * 显示错误信息，1.5秒后自动关闭。
 * @param {string} message 错误信息
 */
export function error(message) {
  let content = <div className="noti">
    <Icon className="error-icon" type="cross-circle" />
    <div className="noti-body">
      <p>
        {message}
      </p>
    </div>
  </div>
  notification.notice({
    content: content,
    duration: 1.5
  });
}

function close(key) {
  notification.removeNotice(key);
}
let isShowing = false;
/**
 * 显示收藏成功提示框，1.5秒后自动关闭。
 * @param {boolean} hasConfirm - 是否显示确定按钮。显示确定按钮不会自动关闭提示框。
 */
export function showClippingSuccess(hasConfirm) {
  if (isShowing)
    return;
  const successIconUrl = require('./images/success.png');
  const key = Date.now();
  let confirm = () => {
    close(key);
    isShowing = false;
  }
  let content = <div className="noti">
    <img
      className="noti-icon"
      src={successIconUrl}
      alt={t('commonClippingSuccess')} />
    <div className="noti-body">
      <p>
        {t('commonClippingSuccess')}
      </p>
    </div>
    {hasConfirm && <div className="noti-footer">
      <Button type="primary"
        size="large"
        onClick={() => { confirm() }}>
        {t('commonConfirm')}
      </Button>
    </div>}
  </div>
  notification.notice({
    content: content,
    duration: hasConfirm ? null : 1.5,
    key: key,
    onClose: () => {
      isShowing = false;
    }
  });
  isShowing = true;
}
/**
 * 显示收藏已满提框,1.5秒后自动关闭。
 */
export function showClippingFull() {
  const warningIconUrl = require('./images/warning.png');
  let content = <div className="noti">
    <img className="noti-icon" src={warningIconUrl} alt={t('commonClippingFull')} />
    <div className="noti-body">
      <span>{t('commonClippingFull')}</span>
    </div>
  </div>
  notification.notice({ content: content });
}
let isShowingAuth = false;
/**
 * 显示认证提示框，登录和注册都会刷新页面。
 */
export function showAuth() {
  if (isShowingAuth) return;
  const key = Date.now();
  const regIconUrl = require('./images/reg.png');
  let navTo = (url) => {
    window.location.assign(url);
    close(key);
    isShowingAuth = false;
    window.location.reload();
  }
  let content = <div className="auth">
    <img className="auth-icon" src={regIconUrl} alt="" />
    <div className="auth-body">
      <p className="auth-title">{t('commonLoginTitle')}</p>
      <p className="auth-content">{t('commonLoginContent')}</p>
    </div>
    <div className="auth-footer">
      <Button className="auth-reg-btn"
        onClick={() => navTo('#/register')}>
        註冊
      </Button>
      <Button className="auth-login-btn"
        onClick={() => navTo('#/login')}>
        {t('commonLogin')}
      </Button>
    </div>
  </div>
  notification.notice({
    content: content,
    duration: null,
    closable: true,
    key: key,
    onClose: () => {
      isShowingAuth = false;
    }
  });
  isShowingAuth = true;
}

export function info(message) {
  const key = Date.now();
  let confirm = () => {
    close(key);
    isShowing = false;
  }
  let content = <div className="noti">
    <Icon className="info-icon" type="exclamation-circle" />
    <div className="noti-body" style={{marginTop: "5px"}}>
      <p>
        {message}
      </p>
    </div>
    <div className="noti-footer" style={{marginTop: "5px"}}>
      <Button type="primary"
        size="large"
        onClick={() => { confirm() }}>
        {t('commonConfirm')}
      </Button>
    </div>
  </div>
  notification.notice({
    content: content,
    key,
    duration: null
  });
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/notification/index.js
 **/